import { matchMockApiRequest, resolveMockApiPathname } from './handlers/mock-api-handlers.registry';

import { of } from 'rxjs';

import { HttpInterceptorFn, HttpResponse } from '@angular/common/http';

import { ApiRuntimeMode } from '@core/runtime/api-runtime-mode';

import { environment } from '@environments/environment';

/**
 * Modo mock (`build:mock` / `start:mock` apenas): interceptor na borda.
 * - Requisições cujo pathname não começa com `/api/` seguem com `next` (i18n, assets, restante da app).
 * - Requisições para `/api/**` com handler registrado: resposta 200 e corpo do mock.
 * - Requisições para `/api/**` sem handler: 501 e corpo JSON (sem contato com backend real).
 */
export const mockApiBoundaryInterceptor: HttpInterceptorFn = (req, next) => {
  if (environment.apiRuntimeMode !== ApiRuntimeMode.Mock)
    return next(req);

  if (!resolveMockApiPathname(req.url).startsWith('/api'))
    return next(req);

  const matched = matchMockApiRequest(req);

  if (matched != null)
    return matched;

  const path = resolveMockApiPathname(req.url);

  return of(
    new HttpResponse({
      body: {
        error: 'mock_handler_not_found',
        method: req.method,
        path,
      },
      status: 501,
    }),
  );
};
